import { render, staticRenderFns } from "./RisksIcon.vue?vue&type=template&id=fabbb4b4"
import script from "./RisksIcon.vue?vue&type=script&lang=js"
export * from "./RisksIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports